export default __webpack_public_path__ + "static/media/profile.4b30efb9.jpg";